<template>
  <div style="padding: 10px">
    <el-page-header @back="goBack" :content="getStuSmartPavilionAppointStatusName(appoint.status)"/>
    <el-card class="box-card">
      <PavilionAppointInfo :appoint="appoint"/>
    </el-card>
    <p class="text-center mt10" style="margin-bottom: 10px">
      {{ getStuSmartPavilionAppointStartTime(appoint) }}
    </p>
    <el-button
      v-if="appoint.status === 0 && getRemainingTime(appoint.appointDate + ' ' + appoint.startTime) > 0"
      type="primary" round style="width: 100%" @click="cancelAppointDialog = true">取消预约
    </el-button>
    <p v-else class="text-center" :class="getStuSmartPavilionAppointStatusClass(appoint.status)">
      {{ getStuSmartPavilionAppointStatusName(appoint.status) }}</p>
    <el-dialog
      title="取消确认"
      :visible.sync="cancelAppointDialog"
      width="100%"
      :show-close="false"
      class="cancelAppoint"
    >
      <p style="font-size: 20px;font-weight: bolder">是否取消预约？</p>
      <span slot="footer">
        <el-button @click="cancelAppointDialog = false" round>取 消</el-button>
        <el-button type="primary" @click="cancelAppoint(appoint)" round>确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapState} from "vuex";
import PavilionAppointInfo from '@/components/pavilionAppointInfo'
import {
  getRemainingTime,
  getStuSmartPavilionAppointStartTime,
  getStuSmartPavilionAppointStatusClass,
  getStuSmartPavilionAppointStatusName
} from "@/assets/js/pavilion";
import {goBack} from "@/assets/js/consult";
import HttpRequest from "@/utils/request";

export default {
  components: {
    PavilionAppointInfo,
  },
  data() {
    return {
      cancelAppointDialog: false,
      appoint: {}
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  // activated() {
  //   let params = JSON.parse(this.$route.query.params)
  //   if (params) {
  //     this.appoint = params
  //     this.$forceUpdate()
  //   } else {
  //     this.$alert(
  //       '请求url缺乏必须的参数',
  //       {confirmButtonText: '返回', showClose: false})
  //       .then(() => {
  //         this.$router.go(-1);
  //       })
  //   }
  // },
  created() {
    let params = JSON.parse(this.$route.query.params)
    if (params) {
      this.appoint = params
      this.$forceUpdate()
    } else {
      this.$alert(
        '请求url缺乏必须的参数',
        {confirmButtonText: '返回', showClose: false})
        .then(() => {
          this.$router.go(-1);
        })
    }
  },
  mounted() {
    document.title = '预约详情';
  },
  methods: {
    goBack,
    getRemainingTime,
    getStuSmartPavilionAppointStartTime,
    getStuSmartPavilionAppointStatusName,
    getStuSmartPavilionAppointStatusClass,
    cancelAppoint(appoint) {
      let url = "/constub/pavilionAppoint/cancelPavilionAppoint";
      let data = {
        token: this.student.token,
        appointId: appoint.id,
        encrypKey: appoint.encrypKey
      };
      HttpRequest.requestFormPost(url, data).then((res) => {
        this.cancelAppointDialog = false
        if (res && res.result.success) {
          this.appoint.status = 10
          this.$message({
            message: '预约取消成功',
            type: 'success'
          });
        } else {
          this.$message({
            message: res.result.message,
            type: 'warning'
          });
        }
      });

    }

  }
};
</script>
<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}
</style>
